export const ErrorMessages = {
  AuthenticationError: '[GraphQL] authentication_error',
  InternalServerError: '[GraphQL] internal_server_error',
  SignInTokenExpiredError: '[GraphQL] sign_in_token_expired',
  PaginatorError: '[GraphQL] paginator_error',
  AccessDenied: '[GraphQL] access_denied',
  BadRequest: '[GraphQL] bad_request',
  TooManyFailedLoginAttemptsError: '[GraphQL] too_many_failed_login_attempts',

  // User errors
  InvalidNewPasswordError: '[GraphQL] invalid_new_password',
  InvalidOldPasswordError: '[GraphQL] invalid_old_password',
  InvalidTokenError: '[GraphQL] invalid_token',
  ExpiredTokenError: '[GraphQL] expired_token',
  InvalidSecretError: '[GraphQL] invalid_secret',
  DuplicateNewPasswordError: '[GraphQL] duplicate_new_password',
  InvalidTimeoutError: '[GraphQL] invalid_timeout',
  InvalidHistoryGraphRange: '[GraphQL] invalid_history_graph_range',

  // exchange order
  InvalidDate: '[GraphQL] invalid_date',
  NotFoundError: '[GraphQL] not_found',
};

export const ErrorDescriptions: { [key: string]: string } = {
  '[GraphQL] authentication_error': 'serverErrors.authentication_error',
  '[GraphQL] internal_server_error': 'serverErrors.internal_server_error',
  '[GraphQL] sign_in_token_expired': 'serverErrors.sign_in_token_expired',
  '[GraphQL] paginator_error': 'serverErrors.paginator_error',
  '[GraphQL] access_denied': 'serverErrors.access_denied',
  '[GraphQL] bad_request': 'serverErrors.bad_request',
  '[GraphQL] too_many_failed_login_attempts': 'serverErrors.too_many_failed_login_attempts',
  '[GraphQL] invalid_new_password': 'serverErrors.invalid_new_password',
  '[GraphQL] invalid_old_password': 'serverErrors.invalid_old_password',
  '[GraphQL] invalid_token': 'serverErrors.invalid_token',
  '[GraphQL] expired_token': 'serverErrors.expired_token',
  '[GraphQL] invalid_secret': 'serverErrors.invalid_secret',
  '[GraphQL] duplicate_new_password': 'serverErrors.duplicate_new_password',
  '[GraphQL] invalid_timeout': 'serverErrors.invalid_timeout',
  '[GraphQL] invalid_history_graph_range': 'serverErrors.invalid_history_graph_range',
  '[GraphQL] invalid_date': 'serverErrors.invalid_date',
  '[GraphQL] not_found': 'serverErrors.not_found',
};
